module.exports = __webpack_public_path__ + "static/media/boat-battle.879b3b6a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/boat-battle.mp3
// module id = 1299
// module chunks = 0